/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/input-message/css/input-message';
import '../../../atoms/link/css/link';
import '../../../atoms/svg/css/svg';
import '../../../atoms/select/css/select';
import '../../../atoms/text/css/text';
import '../../../atoms/text-input/css/text-input';
import '../../../atoms/text-area/css/text-area';
import '../../../molecules/fieldset/css/fieldset';
import '../../../molecules/checkbox-group/css/checkbox-group';
import '../../../molecules/radiobutton-group/css/radiobutton-group';
import '../../../molecules/file-upload/css/file-upload';
import './form-element.scss';
import './modifiers/form-element-state-error.scss';
import './modifiers/form-element-date-picker.scss';
import './modifiers/form-element-no-padding.scss';
import './modifiers/form-element-disclaimer.scss';
